import * as T from '@radix-ui/react-toggle';
import type { ComponentProps } from 'react';

/**
 * A button that stays pressed or not (Radix Toggle): `aria-pressed` and `data-state`
 * ("on" / "off") from Radix, Space and Enter as any button. No look of its own: the caller's
 * `className` styles it (keyed on `[aria-pressed='true']`). Controlled (`pressed`,
 * `onPressedChange`) or not (`defaultPressed`).
 *
 *   <Toggle className="rxp" pressed={mine} onPressedChange={say} aria-label="Well done, Ellie">Well done</Toggle>
 */
export function Toggle(props: ComponentProps<typeof T.Root>) {
	return <T.Root type="button" {...props} />;
}
